<script>
    import { goBack } from "../../Utils/utilFunctions.svelte";

    export let backFunc = () => {
        goBack();
    };
</script>

<span on:click|preventDefault={backFunc} class="cursor-pointer">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 8H1" stroke="#6F726C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M8 15L1 8L8 1" stroke="#6F726C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</span>
